import { FC } from 'react';

import MenuContext from './useMenu/context';
import MenuProvider, { MenuProviderProps } from './useMenu/provider';
import { MenuButton } from './MenuButton';
import { MenuChipButton } from './MenuChipButton';
import { MenuContent, MenuContentProps } from './MenuContent';
import { MenuIconButton } from './MenuIconButton';
import { MenuItem, MenuItemProps } from './MenuItem';
import { MenuLink } from './MenuLink';

export type MenuSubTypes = {
  Button: typeof MenuButton;
  ChipButton: typeof MenuChipButton;
  Content: typeof MenuContent;
  IconButton: typeof MenuIconButton;
  Item: typeof MenuItem;
  Link: typeof MenuLink;
};

export const Menu: FC<MenuProviderProps> & MenuSubTypes = ({ children, ...rest }) => (
  <MenuProvider {...rest}>{children}</MenuProvider>
);

Menu.Button = MenuButton;
Menu.ChipButton = MenuChipButton;
Menu.Content = MenuContent;
Menu.IconButton = MenuIconButton;
Menu.Item = MenuItem;
Menu.Link = MenuLink;

export { MenuContext, MenuProvider };
export type { MenuContentProps, MenuItemProps };
